import {GridLogicOperator} from "@mui/x-data-grid-premium";

export const EMPTY_FILTER = {
    items: [],
    logicOperator: GridLogicOperator.And,
    quickFilterValues: [],
    quickFilterLogicOperator: GridLogicOperator.And,
}
